import React, { useEffect } from 'react'
import striptags from 'striptags'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faSort } from '@fortawesome/fontawesome-pro-solid'

const RenderFormField = ({
  label,
  sublabel,
  placeholder,
  type,
  customClasses = '',
  autoComplete = 'off',
  autoFocus = false,
  input: { name, value, ...inputRest },
  meta: { touched, error, warning },
}) => {
  const errorClass = touched && error ? 'form-control--error--input' : ''
  const errorDisplay =
    touched &&
    ((error && (
      <span
        className='form-control--error'
        dangerouslySetInnerHTML={{ __html: striptags(error, ['a', 'br']) }}
      />
    )) ||
      (warning && (
        <span
          className='form-control--warning'
          dangerouslySetInnerHTML={{ __html: striptags(warning, ['a']) }}
        />
      )))

  const sublabelComponent = sublabel ? (
    <span className='form-control--sublabel'> {sublabel}</span>
  ) : null
  const labelComponent = label ? (
    <label className='form-control--label' htmlFor={name}>
      {label}
      {sublabelComponent}
    </label>
  ) : null

  const checkboxLabelComponent = label ? (
    <label className='form-control--checkbox-label' htmlFor={name}>
      {label}
      {sublabelComponent}
    </label>
  ) : null

  return (
    <div className='form-group'>
      {type !== 'checkbox' && labelComponent}
      <input
        id={name}
        name={name}
        value={value}
        {...inputRest}
        type={type}
        placeholder={placeholder}
        className={`form-control ${customClasses} ${errorClass}`}
        autoComplete={autoComplete}
        data-ext={name}
        autoFocus={autoFocus}
      />
      {type === 'checkbox' && checkboxLabelComponent}
      {errorDisplay}
    </div>
  )
}

export const RenderHiddenFormField = ({
  type,
  options,
  input: { name, value, onChange, ...inputRest },
  meta: { touched, error, warning },
  ...rest
}) => {
  useEffect(() => {
    const targetNode = document.getElementsByName(name)[0]
    // set existing value
    onChange(targetNode.value)
    const config = { attributes: true, childList: false, subtree: false }
    const callback = function(mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes') {
          onChange(mutation.target.value)
        }
      }
    }

    const observer = new MutationObserver(callback)
    observer.observe(targetNode, config)

    return function cleanup() {
      observer.disconnect()
    }
  })
  return (
    <input
      id={name}
      name={name}
      value={value}
      {...inputRest}
      type={type}
      data-ext={name}
    />
  )
}

const renderSelectFieldOption = option => {
  return (
    <option key={option.value} value={option.value} disabled={option.disabled}>
      {option.label}
    </option>
  )
}

export const RenderSelectField = ({
  label,
  sublabel,
  options,
  customClasses = '',
  input: { name, value, ...inputRest },
  meta: { touched, error, warning },
}) => {
  const errorClass = touched && error ? 'form-control--error--input' : ''
  const errorDisplay =
    touched &&
    ((error && (
      <span
        className='form-control--error'
        dangerouslySetInnerHTML={{ __html: striptags(error, ['a']) }}
      />
    )) ||
      (warning && (
        <span
          className='form-control--warning'
          dangerouslySetInnerHTML={{ __html: striptags(warning, ['a']) }}
        />
      )))

  const sublabelComponent = sublabel ? (
    <span className='form-control--sublabel'> {sublabel}</span>
  ) : null
  const labelComponent = label ? (
    <label className='form-control--label' htmlFor={name}>
      {label}
      {sublabelComponent}
    </label>
  ) : null

  return (
    <div className='form-group'>
      {labelComponent}
      <div className='form-control__select'>
        <select
          id={name}
          name={name}
          value={value}
          data-ext={name}
          {...inputRest}
          className={`form-control form-control__select__input ${customClasses} ${errorClass}`}
        >
          {options.map(renderSelectFieldOption)}
        </select>
        <FontAwesomeIcon className='form-control__select__icon' icon={faSort} />
      </div>
      {errorDisplay}
    </div>
  )
}

export default RenderFormField
